import { render, staticRenderFns } from "./ModalCustomerResource.vue?vue&type=template&id=0acbbd7e&scoped=true&"
import script from "./ModalCustomerResource.vue?vue&type=script&lang=js&"
export * from "./ModalCustomerResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustomerResource.vue?vue&type=style&index=0&id=0acbbd7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbbd7e",
  null
  
)

export default component.exports